import { isFunction } from './is-function.js';

/**
 * @description
 * Checks if `value` is the language type of Object. (e.g. arrays, objects, regexes, new Number(0), and new String(''))
 *
 * @example
 * ``` ts
 * isObject(() => {});
 * // => true
 * isObject(new A());
 * // => true
 * isObject({});
 * // => true
 * isObject(null);
 * // => false
 * ```
 *
 * @param value The value to check.
 * @param failfn The value indicate if function is Object?, default false
 * @returns Returns true if value is an object, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-object
 */
export const isObject = (value, failfn = false): boolean => {
  const t = typeof value;
  return (
    (value &&
      (t === 'object' ||
        (!failfn && (t === 'function' || isFunction(value))))) ||
    false
  );
};
